import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import{ AngularFire } from 'angularfire2';


/*
  Generated class for the Creation page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.

  La page de création est accéssible uniquement depuis la page home, elle s'occupe de créér un nouveau compte.
*/
@Component({
  selector: 'page-creation',
  templateUrl: 'creation.html'
})
export class CreationPage {
  email:string;
  password:string;
  creds: any;
  constructor(public navCtrl: NavController,
              public af: AngularFire) {}

  ionViewDidLoad() {
    console.log('Hello CreationPage Page');
  }
  //Lorsque cette méthode est appellée, on crée un nouvel utilisateur sur la base de données de firebase
  createAccount(){
    this.creds= {email: this.email,
                password: this.password}
    this.af.auth.createUser(this.creds);
  }

}



// WEBPACK FOOTER //
// ./src/pages/creation/creation.ts